module.exports = __webpack_public_path__ + "img/log.b8e5a49c.svg";